module.exports = __webpack_public_path__ + "static/e-commerce-00e4368b019d9c24c10bdfa8caed7f0f.jpg";